<template>
  <svg
    aria-hidden="true"
    type="1"
    width="25px"
    height="25px"
    class="as-incident-list__icon"
  >
    <use href="#icon-goal"></use>
  </svg>
</template>

<script lang="ts">
export default {};
</script>
